import FeatureFlagService from "../../services/featureFlag.service";
import { updateActiveKeyFeatureLabel } from "../../i18n";
import { ERROR_MESSAGE } from "../../utils/constants";
import { getFeatureFlags, setLocalFeatureFlags, throwError, to, toastMessage } from "../../utils/utils";
import ACTIONS from "./types.actions";

const FEATURE_FLAG_LOADING = "loading";
const FEATURE_FLAG_MUTATION_LOADING = "mutationLoading";
const PROPERTY_SEARCH_REDESIGN_FLAG = "property_search_redesign";
const NEARBY_ROUTE_FEATURE_DISABLED_MESSAGE = "Feature is not enabled";
let latestFeatureFlagsRequest;

const getFailClosedFeatureFlags = cachedFlags => {
  const normalizedFlags =
    cachedFlags && typeof cachedFlags === "object" && !Array.isArray(cachedFlags) ? cachedFlags : {};
  const cachedRedesignFlag = normalizedFlags[PROPERTY_SEARCH_REDESIGN_FLAG];
  const normalizedRedesignFlag =
    cachedRedesignFlag && typeof cachedRedesignFlag === "object" && !Array.isArray(cachedRedesignFlag)
      ? cachedRedesignFlag
      : {};

  return {
    ...normalizedFlags,
    [PROPERTY_SEARCH_REDESIGN_FLAG]: {
      ...normalizedRedesignFlag,
      status: false,
    },
  };
};

export function featureFlagRequest(key = FEATURE_FLAG_LOADING) {
  return { type: ACTIONS.FEATURE_FLAG_REQUEST, key };
}

export function featureFlagListSuccess(response) {
  return { type: ACTIONS.FEATURE_FLAG_LIST_SUCCESS, response };
}

export function featureFlagSuccess(response, key = FEATURE_FLAG_LOADING) {
  return { type: ACTIONS.FEATURE_FLAG_SUCCESS, response, key };
}

export function featureFlagError(error, key = FEATURE_FLAG_LOADING) {
  return { type: ACTIONS.FEATURE_FLAG_ERROR, error, key };
}

export function featureFlagListError(error, fallbackFlags) {
  return { type: ACTIONS.FEATURE_FLAG_LIST_ERROR, error, response: fallbackFlags };
}

export function toggleFeatureFlags(payload) {
  return async dispatch => {
    dispatch(featureFlagRequest(FEATURE_FLAG_MUTATION_LOADING));
    try {
      const [err] = await to(FeatureFlagService.update(payload.id, payload));
      if (err) throwError(err);
      dispatch(featureFlagSuccess(undefined, FEATURE_FLAG_MUTATION_LOADING));
    } catch (error) {
      dispatch(featureFlagError(error, FEATURE_FLAG_MUTATION_LOADING));
      toastMessage("error", ERROR_MESSAGE.EDITED);
      throwError(error);
    }
  };
}

export function getAllFeatureFlags() {
  return async dispatch => {
    const requestToken = {};
    latestFeatureFlagsRequest = requestToken;
    const isLatestRequest = () => latestFeatureFlagsRequest === requestToken;

    dispatch(featureFlagRequest());
    try {
      const [err, response] = await to(FeatureFlagService.getAll());
      if (!isLatestRequest()) return;
      if (err) throwError(err);
      const flagsLookup = {};
      if (response.length > 0) {
        response.forEach(element => {
          if (!flagsLookup[element.id]) {
            flagsLookup[element.id] = element;
          }
        });
      }
      setLocalFeatureFlags(flagsLookup);
      updateActiveKeyFeatureLabel(Boolean(flagsLookup[PROPERTY_SEARCH_REDESIGN_FLAG]?.status));
      dispatch(featureFlagSuccess(flagsLookup));
      dispatch(featureFlagListSuccess(response));
    } catch (error) {
      if (!isLatestRequest()) return;
      const failClosedFlags = getFailClosedFeatureFlags(getFeatureFlags());
      setLocalFeatureFlags(failClosedFlags);
      updateActiveKeyFeatureLabel(false);
      dispatch(featureFlagListError(error, failClosedFlags));
      toastMessage("error", ERROR_MESSAGE.LIST);
      throwError(error);
    }
  };
}

export function refreshFeatureFlagsAfterBudSyncDisabled(error) {
  return async dispatch => {
    const isBudSyncDisabled =
      error?.response?.status === 403 && error?.response?.data?.message === "BUD Sync feature is disabled.";
    if (!isBudSyncDisabled) return false;

    await to(dispatch(getAllFeatureFlags()));
    return true;
  };
}

export const isNearbyRouteFeatureDisabledError = error =>
  error?.response?.status === 404 && error?.response?.data?.message === NEARBY_ROUTE_FEATURE_DISABLED_MESSAGE;

export function refreshFeatureFlagsAfterNearbyRouteDisabled(error) {
  return async dispatch => {
    if (!isNearbyRouteFeatureDisabledError(error)) return false;

    await to(dispatch(getAllFeatureFlags()));
    return true;
  };
}
